export default {
  common: {
    back: "返回",
    cancel: "取消",
    submit: "提交",
    loading: "拼命加載中",
    noData: "暫無數據",
    copySuccess: "複製成功",
  },
  index: {
    title: "AI模型",
    cards: {
      gasfee: {
        title: "首筆手續費追溯",
        desc: "追溯單個地址5級之內的交易所地址",
      },
      multilayer: {
        title: "多層追溯",
        desc: "追溯流單個地址最多3級之內的轉入或者轉出交易路徑",
      },
      transactionpath: {
        title: "交易路徑分析",
        desc: "分析2級內多個起始地址到終點地址中的途徑點和交易路徑",
      },
      associatedGasFee: {
        title: "關聯手續費追溯",
        desc: "一鍵鎖定手續費關聯的可調證地址",
      },
      tornado: {
        title: "龍捲風模型",
        desc: "智能穿透追蹤混幣平台數據，支持雙向溯源",
      },
      newOldStop: {
        title: "新啟舊停模型",
        desc: "自動追蹤黑灰產資金從舊地址到新地址的遷移鏈路",
        tooltip:
          "新啟舊停模型用於分析黑灰產地址的遷移行為。用戶可指定目標地址與篩選條件，系統將自動檢索該地址的最早或最新一筆交易，識別地址啟用或停用狀態。模型可發現黑灰產在更換收款地址時的整筆資金轉移，有助於追蹤其最新活躍地址或反向查找歷史地址，為鏈上追蹤與風險分析提供關鍵線索。",
      },
      singleChannel: {
        title: "單通道中轉模型",
        desc: "自動追蹤其上/下游資金流動，識別單通道的中轉鏈路",
        tooltip:
          "該模型用於識別黑灰產資金轉移過程中的中轉行為。系統會以指定地址為起點，逐層分析其資金流入和流出關係，尋找資金流高度集中的地址鏈路。模型會沿著這類高依賴的轉移路徑持續追蹤，直到資金出現分散流動，從而揭示黑灰產資金的主要中轉路徑。",
      },
    },
  },
  gasfee: {
    title: "首筆手續費追溯",
    empty: {
      title: "暫無數據",
      tip: "請在畫布中選擇節點後右鍵或者點擊頂部AI模型下的按鈕選擇首筆手續費追溯",
    },
    basicInfo: {
      verifyType: "模型驗證類型",
      feeModel: "手續費模型",
    },
    result: {
      titlePrefix: "分析結果:",
      firstSourceLevel: "首筆手續費來源層級",
      sourceLevel: "手續費來源層級",
      firstSourcePlatform: "首筆手續費來源平台",
      firstSourceAddress: "首筆手續費來源地址",
      sourceAddress: "手續費來源地址",
      firstSourceHash: "首筆手續費來源hash",
      sourceHash: "手續費來源hash",
      firstSourceTime: "首筆手續費來源時間",
      sourceTime: "手續費來源時間",
      firstSourceQuantity: "首筆手續費來源數量",
      sourceQuantity: "手續費來源數量",
    },
    survey: {
      add: "添加調證",
      normal: "普通調證",
      important: "重點調證",
    },
  },
  multilayer: {
    title: "多層追溯",
    form: {
      addressLabel: "分析地址",
      addressPlaceholder: "請輸入地址",
      currencyLabel: "幣種選擇",
      currencyPlaceholder: "請選擇幣種",
      directionLabel: "方向",
      directionPlaceholder: "請選擇方向",
      directionOptions: {
        OUTFLOW: "流出",
        INFLOW: "流入",
      },
      levelLabel: "關聯層級",
      levelPlaceholder: "請選擇層級",
      cancel: "取消",
      submit: "提交",
    },
    result: {
      analysisAddress: "[分析地址]",
      calculationCurrency: "[計算幣種]",
      analysisBanner: "分析結果: 已經追溯到{count}條交易路徑",
      graphAnalysis: "上圖分析",
      level: "層級:",
      tag: "標籤:",
      levelTotalQuantityDesc: "當前路徑的{depth}級交易總數量",
      outflow: "轉出",
      inflow: "轉入",
      traceTo: "追溯至:",
      levelUnit: "級",
      levelTransaction: "級交易數量",
    },
  },
  transactionpath: {
    title: "交易路徑分析",
    form: {
      fromAddressLabel: "起始地址",
      multiTip: "多個地址請換行(ctrl/⌘+回車)隔開",
      fromAddressPlaceholder: "請輸入地址，最多輸入5個地址",
      toAddressLabel: "終點地址",
      toAddressPlaceholder: "請輸入地址，最多輸入5個地址",
      swapTip: "起始/終點位置交換",
      currencyTypeLabel: "幣種類型",
      currencyPlaceholder: "請選擇幣種",
      associationLabel: "關聯層級",
      associationPlaceholder: "請選擇活動區域",
      cancel: "取消",
      submit: "提交",
      validators: {
        currencyRequired: "請選擇幣種",
        fromRequired: "請輸入起始地址",
        toRequired: "請輸入終點地址",
        maxFive: "最多只能輸入5個地址",
      },
      clear: "清空",
    },
  },
  transactiontabel: {
    title: "交易路徑分析",
    summary: {
      startAddresses: "[起始地址]",
      endAddresses: "[終點地址]",
      completionTime: "[完成時間]",
      calculationCurrency: "[計算幣種]",
      calculationLevel: "[計算層級]",
    },
    result: {
      summary: "分析結果：{pathCount}條交易路徑，涉及途徑地址{wayPointCount}個",
    },
    table: {
      waypoint: "途徑點",
      totalInflow: "累計流入",
      totalOutflow: "累計流出",
      ioTip:
        "途徑地址的累計流入/流出交易數據，僅統計符合條件的交易路徑中的交易數據",
      txCount: "交易筆數",
      txCountTip: "流入筆數/流出筆數",
      action: "操作",
      graphAnalysis: "上圖分析",
      empty: "暫無數據",
    },
  },
  alternation: {
    newOldStop: "新啟舊停模型",
    singleChannel: "單通道中轉模型",
    form: {
      addressLabel: "分析地址",
      addressPlaceholder: "請輸入地址",
      currencyLabel: "幣種選擇",
      currencyPlaceholder: "請選擇幣種",
      directionLabel: "方向",
      directionPlaceholder: "請選擇方向",
      directionOptions: {
        INFLOW: "流入",
        OUTFLOW: "流出",
      },
      amountLabel: "交易金額",
      levelLabel: "追溯最大層級",
      levelPlaceholder: "請選擇層級",
      levelRange: "關聯層級必須在1-20之間",
      endTimeLabel: "追溯截止時間",
      endTimePlaceholder: "選擇日期時間",
    },
    history: {
      add: "新增",
      direction: "方向：",
      submitTime: "提交時間：",
      status: {
        computing: "計算中",
        success: "計算成功",
        failed: "計算失敗",
      },
    },
    result: {
      computing: "正在計算中",
      computingTip: "請等待成功後再查看詳情",
      failed: "計算失敗",
      failedTip: "系統異常，可稍後重試",
      calculateAddress: "[計算地址]",
      completionTime: "[完成時間]",
      calculationCurrency: "[計算幣種]",
      calculationDirection: "[計算方向]",
      analysisBanner: "分析結果：涉及關聯地址{count}個",
      graphAnalysis: "上圖分析",
      relatedAddress: "關聯地址",
      level: "層級",
      amount: "金額",
      time: "時間",
      action: "操作",
      dataDetail: "數據明細",
    },
    messages: {
      computingNotice: "正在計算中，請等待成功後再查看詳情",
      addFailed: "新增失敗",
    },
  },
};
